import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Paper from '@mui/material/Paper';
import React, { useEffect, useState } from 'react';
import useApiContext from '@sb1finans/components/dist/ApiProvider';
import { FormattedCurrency } from '@sb1finans/components/dist/FormattedCurrency';
import { IncomingPayment } from '@sb1finans/new-api/dist/api';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { use } from 'i18next';
import { usePaymentPlan } from '..';

interface AccountPaymentPlanProps {
    payments: IncomingPayment[]
    loading: boolean
    error: Error | null
}

export const AccountPaymentPlan: React.FC<AccountPaymentPlanProps> = ({payments, error, loading}) => {

    return (
        <TableContainer component={Paper}>
            {loading && <CircularProgress id="loading-spinner" aria-label='loading-spinner' />}
            {error && <Alert severity="error">{error.message}</Alert>}
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Dato</TableCell>
                <TableCell align="right">Beløp</TableCell>
                <TableCell align='right'>Avdrag</TableCell>
                <TableCell align="right">Gebyr</TableCell>
                <TableCell align="right">Renter</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payments?.map((payment) => {
                const date = new Date(payment.dueDate)
                const dateString = `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`
                return (
                    <TableRow
                      key={payment.dueDate}
                      sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {dateString}
                      </TableCell>
                      <TableCell align="right"><FormattedCurrency round={true}>{payment.amount}</FormattedCurrency></TableCell>
                      <TableCell align="right"><FormattedCurrency round={true}>{payment.amount - payment.fees - payment.interest}</FormattedCurrency></TableCell>
                      <TableCell align="right"><FormattedCurrency round={true}>{payment.fees}</FormattedCurrency></TableCell>
                      <TableCell align="right"><FormattedCurrency round={true}>{payment.interest}</FormattedCurrency></TableCell>
                    </TableRow>
              )})}
            </TableBody>
          </Table>
        </TableContainer>
    )
}

interface AccountPaymentPlanWithDataProps {
  agreementId: string
  accountId: string
}